import React, {
  Component,
} from 'react';
import 'react-input-range/lib/css/index.css';
import {
  Manager,
  Reference,
  Popper,
} from 'react-popper';
import { Link } from 'react-router-dom';
import ArrowBackBtn from '../ArrowBackBtn';
import Suggestions from './Suggestions';
import {
  isAnyOptions,
  getSearchQueryUrl,
} from '../../helpers/searchBarHelper';
import SearchLogoUrl from './images/search_logo_green.png';
import {
  BODY_TEXT_COLOR,
  WHITE,
  SUGGESTIONS_BACKGROUND,
} from '../../config/colors';

const STYLES = {
  placeHolderText: {
    fontSize: 14,
    padding: '0 30px',
    lineHeight: '26px',
    color: WHITE,
  },
  closeIcon: {
    position: 'absolute',
    top: 18,
    right: 12,
    fontSize: 12,
    color: BODY_TEXT_COLOR,
  },
  container: {
    minHeight: '100vh',
    background: SUGGESTIONS_BACKGROUND,
  },
};

class SearchBarMobile extends Component {
  state = { searchString: '' };

  preventOSkeyboardFromPushingTheViewOffScreen() {
    document.addEventListener("touchmove", (e) => {
      e.preventDefault();
    });
    setTimeout(() => {
      window.scrollTo(0, 0);
      document.body.scrollTop = 0;
    }, 300);
  }

  handleChangeSearch = async (e) => {
    const searchString = e.target.value;

    this.search(searchString);
  };

  clearResult = () => {
    this.props.clear();
    this.inputRef.focus();
  }

  getSecondaryColor = () => {
    return `#${this.props.secondaryColor}`
  }

  render() {
    const {
      brands,
      types,
      subTypes,
      products,
      classifications,
      flavors,
      generals,
      effects,
    } = this.props.results;

    const {
      secondaryColor,
      customerType,
      salesChannelName,
    } = this.props;

    return (
      <div style={STYLES.container}>
        <Manager>
          <Reference>
            {({ ref }) => (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  this.props.onSubmit(this.props.value);
                }}
              >
                <div className="search-sm">
                  <span onClick={this.props.onClose} style={{ position: 'absolute', left: 5, top: 11 }}>
                    <ArrowBackBtn borderWeight="0" color={secondaryColor} />
                  </span>
                  <input
                    autoComplete={`off`}
                    autoFocus = { true }  
                    onChange = { ({ target: { value } }) => this.props.onChange(value) }
                    spellCheck = { false }
                    value = { this.props.value }
                    ref={inputRef => this.inputRef = inputRef}
                    placeholder="Search products"
                    onFocus={this.preventOSkeyboardFromPushingTheViewOffScreen}
                  />
                  { this.props.value && <span onClick={this.clearResult} style={STYLES.closeIcon}>CLEAR</span> }
                </div>
              </form>
            )
            }
          </Reference>
          <div className="results-padding-sm" />
          {isAnyOptions(this.props.results) ? (
            <Popper placement="bottom-start">
              {({ placement, ref, style }) => (
                <div ref={ref} data-placement={placement} className="search-results-sm">
                  <Suggestions
                    types={types}
                    subTypes={subTypes}
                    products={products}
                    brands={brands}
                    classifications={classifications}
                    flavors={flavors}
                    effects={effects}
                    generals={generals}
                    isPhone
                    customerType={customerType}
                   />

                  <Link
                    className="search-result-sm text-center"
                    to={getSearchQueryUrl(this.props.value)}
                  >
                    <div className="result-title-sm">
                      View all results
                    </div>
                  </Link>
                </div>
              )
              }
            </Popper>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ padding: '30px 0 25px' }}>
                <img alt="search" style={{ height: 100 }} src={SearchLogoUrl} />
              </div>
              <div style={STYLES.placeHolderText}>
                <div>You can find products by searching for</div>
                <div>Brand Names, Product Names, Product Types, Classifications, Flavors, Effects.</div>
              </div>
            </div>
          )
          }
        </Manager>
      </div>
    );
  }
}

export default SearchBarMobile;



// WEBPACK FOOTER //
// ./src/components/Search/SearchBarMobile.jsx